import * as React from "react";
import { forwardRef } from "react";
const SvgOptions = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 2, cy: 10, r: 2, fill: "#2F3337" }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 2, fill: "#2F3337" }), /* @__PURE__ */ React.createElement("circle", { cx: 18, cy: 10, r: 2, fill: "#2F3337" }));
const ForwardRef = forwardRef(SvgOptions);
export { ForwardRef as ReactComponent };
